import request from '@/utils/request'

export function getWechatArgs(data) {
  return request({
    url: '/wx/getSignature',
    method: 'post',
    data
  })
}
